import React from "react";
import { IoMdNotifications } from "react-icons/io";
import NotificationsMenu from "./NotificationsMenu";

interface AnnouncementProps {
  isNotificationsOpen: boolean;
  toggleNotifications: (e: React.MouseEvent) => void;
  unReadCount: number;
  onClose: () => void;
  refetch: (refetch?: boolean) => Promise<void>;
}

const Announcement: React.FC<AnnouncementProps> = ({
  isNotificationsOpen,
  toggleNotifications,
  unReadCount,
  onClose,
  refetch,
}) => {
  return (
    <div className="fixed-nav-element" style={{ position: "relative" }}>
      <a
        href="#"
        onClick={toggleNotifications}
        data-notifications-toggle="true"
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: 53,
        }}
      >
        <IoMdNotifications
          size={40}
          fill={isNotificationsOpen ? "#00adec" : "#224984"}
        />
        {unReadCount > 0 && (
          <span
            style={{
              position: "absolute",
              top: -5,
              right: 5,
              background: "red",
              color: "white",
              borderRadius: "50%",
              width: "20px",
              height: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
            }}
          >
            {unReadCount}
          </span>
        )}
        <div
          style={{
            color: isNotificationsOpen ? "#00adec" : "#224984",
            fontSize: 12,
            textAlign: "center",
          }}
        >
          Announcements
        </div>
      </a>
      {isNotificationsOpen && (
        <NotificationsMenu
          refetch={refetch}
          isOpen={isNotificationsOpen}
          onClose={onClose}
        />
      )}
    </div>
  );
};

export default Announcement;
